export default (userClass) => {
  let text;
  switch (userClass) {
    case 'PREMIUM':
      text = '星級商戶';
      break;
    case 'NORMAL':
      text = '普通商戶';
      break;
    default:
      text = '　—　';
      break;
  }
  return { text };
};
